import React from "react";
import { CellGrid, CellProps, Direction } from "./Cell";
import { applyDir, deserialize, invertDir } from "./CellUtils";
import { levels } from "./assets/Levels";
export class Game extends React.Component<{}, { level: number; won: boolean }> {
  constructor() {
    super({});
    (this.state as any) = { level: 0, won: false };
  }
  render() {
    return !this.state.won ? (
      <CellGrid
        {...deserialize(levels[this.state.level])}
        key={this.state.level}
        logic={(x) => this.logic(x)}
      />
    ) : (
      <div>
        Game complete
      </div>
    );
  }
  logic(a: readonly (readonly Readonly<CellProps>[])[]) {
    //whole grid must be filled
    if (a.find((r) => r.find((i) => i.kind === "empty"))) {
      return;
    }
    let nodes = a.flat(2).filter((i) => i.kind === "node");
    // Set of node pairs checked
    let seen = new Set<string>();
    loop: for (let n of nodes) {
      if (seen.has(n.colorlow)) {
        continue;
      }
      seen.add(n.colorlow);
      //@var{d} is the direction to walk
      for (let d of directions) {
        let [x, y] = applyDir(d, [n.x, n.y]);
        //walk the path connecting nodes
        while (true) {
          //2D index out of bounds
          if (x < 0 || y < 0 || y >= a.length || x >= a[y].length) {
            break;
          }
          let c = a[y][x];
          if (c.colorlow !== n.colorlow) {
            //looking at different color
            break;
          }
          if (c.kind === "node" && (c.x !== n.x || c.y !== n.y)) {
            // found other node of color
            continue loop;
          }
          if (c.kind === "path") {
            if (c.directionA === c.directionB) {
              //going to loop
              console.warn(
                `avoided infinite loop in game logic, cell at ${c.x},${c.y} has both directions pointing ${c.directionA}`
              );
              break;
            }
            if (c.directionA === invertDir(d) && c.directionB) {
              //A points back, use B
              [x, y] = applyDir(c.directionB, [x, y]);
              d = c.directionB;
            } else if (c.directionB === invertDir(d)) {
              //B points back, use A
              [x, y] = applyDir(c.directionA, [x, y]);
              d = c.directionA;
            } else {
              //neither A nor B point back, `c` is a different part of the path
              break;
            }
          }
        }
      }
      return;
    }

    this.setState((s) => {
      if (s.level + 1 === levels.length) return { level: 0, won: true };
      return { level: s.level + 1, won: false };
    });
  }
}
const directions: Direction[] = ["up", "right", "down", "left"];
